import React from "react";
import { useStores } from "../store";

export default function FreeInterviews({ availableCredits }) {
  const { PopupStore } = useStores();
  const userDetails = JSON.parse(localStorage.getItem("user"));
  const coins = availableCredits ?? userDetails?.coins;
  const denominator = 10;
  const freeInterviews = (coins / denominator).toFixed(0);

  return (
    <div className="flex items-center ">
      <div className="flex items-center  w-fit rounded-full bg-[#FFD7B9] ">
        {/* <div className="flex justify-between items-center text-black ">
          <p className="md:text-lg lg:text-2xl text-xs md:font-medium lg:font-medium font-normal md:p-3 lg:p-3 p-1 md:px-6 lg:px-6 px-3">
            Free Interviews
          </p>
        </div> */}
        {/* <div className="border md:p-3 lg:p-5 flex justify-center items-center p-1 rounded-full md:px-8 lg:px-10 px-4 h-10 md:h-fit bg-primary text-white">
          <span className="flex justify-between items-center  md:text-xl lg:text-2xl text-sm md:font-bold lg:font-bold font-normal">
            {freeInterviews}
          </span>
        </div> */}
      </div>
      {/* <span
        className="ml-1 md:text-3xl lg:text-4xl text-base text-primary cursor-pointer"
        onClick={() => PopupStore.setKnowMore(true)}
      >
        <MdInfoOutline />
      </span> */}
    </div>
  );
}
